module.exports = __webpack_public_path__ + "static/media/wallpaper-1.01a1295e.jpg";